module.exports = __webpack_public_path__ + "static/media/Danustan_Alphonza_danzilla_danustan_spicy_food_code_hobby_19.10076b87.jpg";